import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Grid } from '@mui/material'

import Select from '../Select'
import { useSelectionSet } from '../../hooks/selection-set-functions'
import { getArePubblicati } from '../../hooks/utils-functions'

const SelectGirone = () => {
  const { admin } = useSelector(state => state.home.infoUtente)
  const availableGironi = useSelector(state => state.selection.availableGironi)
  const selectedGirone = useSelector(state => state.selection.selectedGirone)
  const selectedCampionatoGironiPubblicati = useSelector(
    state => state.selection.selectedCampionatoGironiPubblicati,
  )
  const selectedCampionatoCalendariPubblicati = useSelector(
    state => state.selection.selectedCampionatoCalendariPubblicati,
  )

  const location = useLocation()
  const arePubblicati = getArePubblicati(
    selectedCampionatoGironiPubblicati,
    selectedCampionatoCalendariPubblicati,
    location.pathname?.split('/')?.[1],
  )

  const { setSelectedGirone } = useSelectionSet()

  const value = availableGironi?.includes(selectedGirone)
    ? selectedGirone
    : undefined

  const optionLabels = availableGironi?.map(
    a =>
      (a === null && 'Senza girone') ||
      (a === 'finali' && 'Fasi finali') ||
      (a === 'avulsa' && 'Classifica avulsa') ||
      (a !== availableGironi[0] && `Girone ${a}`) ||
      a,
  )

  return (
    <Grid size={{ xs: 12, md: 2 }}>
      <Select
        id='available-gironi'
        label='Girone'
        value={value}
        options={availableGironi}
        optionLabels={optionLabels}
        autoSelect={false}
        disabled={!availableGironi || (!admin && !arePubblicati)}
        onChange={setSelectedGirone}
      />
    </Grid>
  )
}

export default SelectGirone
